import parse from 'html-react-parser';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

const SubmitMappingModal = ({
    title,
    selectedCategory,
}: {
    title: string;
    selectedCategory: string | undefined;
}) => {
    const { t } = useTranslation();
    return <Flex>{parse(t(title, { selectedCategory }))}</Flex>;
};

export default React.memo(SubmitMappingModal);
